import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Fragment, useMemo } from 'react';
import { CpslButton, CpslDivider, CpslIconGroup } from '@usecapsule/react-components';
import styled from 'styled-components';
import { useExternalWallets } from '../../providers/ExternalWalletContext.js';
import { ExternalWallets } from '../ExternalWallets/ExternalWallets.js';
import { useModalStore, useThemeStore } from '../../stores/index.js';
import { ModalStep } from '../../utils/steps.js';
import { AuthLayout } from '../../types/modalProps.js';
import { brandedOAuthLogos, oAuthLogos } from '../../constants/oAuthLogos.js';
import { AuthOptions } from '../AuthOptions/AuthOptions.js';
export const AuthMainStepContent = ({ oAuthMethods, disableEmailLogin, disablePhoneLogin }) => {
    const { wallets } = useExternalWallets();
    const authLayout = useThemeStore(state => state.authLayout);
    const setStep = useModalStore(state => state.setStep);
    const oAuthLogoVariant = useThemeStore(state => state.oAuthLogoVariant);
    const isDark = useThemeStore(state => state.isDark);
    const useBrandedLogos = oAuthLogoVariant === 'default';
    const useDarkLogos = useBrandedLogos ? isDark : oAuthLogoVariant !== 'dark';
    const handleCondensedAuthClick = () => {
        setStep(ModalStep.AUTH_MORE);
    };
    const handleCondensedExternalClick = () => {
        setStep(ModalStep.EX_WALLET_MORE);
    };
    const Content = useMemo(() => {
        const methods = [];
        authLayout.forEach(layout => {
            switch (layout) {
                case AuthLayout.AUTH_FULL: {
                    methods.push([
                        _jsx(AuthOptions, { oAuthMethods: oAuthMethods, disableEmailLogin: disableEmailLogin, disablePhoneLogin: disablePhoneLogin }, "authFull"),
                        layout,
                    ]);
                    break;
                }
                case AuthLayout.AUTH_CONDENSED: {
                    const icons = [];
                    oAuthMethods === null || oAuthMethods === void 0 ? void 0 : oAuthMethods.forEach(method => icons.push(useBrandedLogos ? brandedOAuthLogos[method] : oAuthLogos[method]));
                    methods.push([
                        _jsxs(CondensedButton, { onClick: handleCondensedAuthClick, variant: "tertiary", fullWidth: true, children: [_jsx(IconGroupSpacer, { slot: "start", icons: [], "$isDark": useDarkLogos }), "Sign Up or Login", _jsx(StyledIconGroup, { slot: "end", icons: icons.splice(0, 3), "$isDark": useDarkLogos })] }, "authCondensed"),
                        layout,
                    ]);
                    break;
                }
                case AuthLayout.EXTERNAL_FULL: {
                    if (!!wallets.length) {
                        methods.push([_jsx(ExternalWallets, {}, "externalWallets"), layout]);
                    }
                    break;
                }
                case AuthLayout.EXTERNAL_CONDENSED: {
                    const icons = [];
                    wallets === null || wallets === void 0 ? void 0 : wallets.forEach(wallet => icons.push(wallet.iconUrl));
                    methods.push([
                        _jsxs(CondensedButton, { onClick: handleCondensedExternalClick, variant: "tertiary", fullWidth: true, children: [_jsx(IconGroupSpacer, { slot: "start", icons: [], "$isDark": useDarkLogos }), "Connect Wallet", _jsx(StyledIconGroup, { slot: "end", icons: icons.splice(0, 3), "$isDark": useDarkLogos })] }, "authCondensed"),
                        layout,
                    ]);
                    break;
                }
                default: {
                    break;
                }
            }
        });
        return (_jsx(_Fragment, { children: methods.map(([reactNode, key], index) => (_jsxs(Fragment, { children: [reactNode, methods.length > 1 && index < methods.length - 1 && _jsx(CpslDivider, { children: "or" }, "or")] }, key))) }));
    }, [oAuthMethods, disableEmailLogin, disablePhoneLogin, wallets, authLayout]);
    return _jsx(Container, { "data-testid": "main-auth-step-content", children: Content });
};
const Container = styled.div `
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
const StyledIconGroup = styled(CpslIconGroup) `
  --icon-item-color: ${({ $isDark }) => ($isDark ? 'white' : 'black')};
  flex: 1;
  justify-content: flex-end;
`;
const IconGroupSpacer = styled(StyledIconGroup) `
  visibility: hidden;
`;
const CondensedButton = styled(CpslButton) `
  --button-justify-content: space-between;

  &::part(button-native) {
    max-height: 50px;
  }
`;
